import { Button, Card, Text } from '@ui/themed';
import { t } from 'i18next';
import { useEnv } from '../../../context/env-context';
import { useHandlers } from '../../../context/page-context';

export function FinishSetupCard() {
  const { store_id } = useEnv();
  const { navigationHandler } = useHandlers();

  // Only show when in the SparkLayer dashboard and they have a store_id
  if (!store_id) {
    return null;
  }

  return (
    <Card>
      <Card.Header
        icon="store"
        headingLevel="h2"
        badges={[
          {
            text: t('features:home.components.finish_setup_card.badge'),
            variant: 'purple',
          },
        ]}
      >
        {t('features:home.components.finish_setup_card.title')}
      </Card.Header>
      <Card.Body>
        {t('features:home.components.finish_setup_card.description')}
        <Text variant="secondary" size="sm">
          {t('features:home.components.finish_setup_card.footer')}
        </Text>
        <Button
          icon="externalLink"
          onClick={() =>
            navigationHandler.navigateById('onboarding.setup', {
              absolute: true,
              newTab: true,
            })
          }
        >
          {t('features:home.components.finish_setup_card.action')}
        </Button>
      </Card.Body>
    </Card>
  );
}
